<template>
  <b-form v-if="user">
    <b-form-group label-for="Email" label="Aktuelle Adresse" label-cols=12 label-cols-md=5 label-cols-lg=6 label-cols-xl=4 label-align-md="right">
      <b-form-input v-model=user.email :disabled=true></b-form-input>
    </b-form-group>

    <b-form-group label-for="Email" label="Neue Email-Adresse" label-cols=12 label-cols-md=5 label-cols-lg=6 label-cols-xl=4 label-align-md="right">
      <b-form-input v-model=email></b-form-input>
    </b-form-group>

    <b-form-group label-for="Email-Confirmation" label="Bestätigen" label-cols=12 label-cols-md=5 label-cols-lg=6 label-cols-xl=4 label-align-md="right">
      <b-form-input v-model=confirmation></b-form-input>
    </b-form-group>

    <b-button type="button" v-on:click=send :disabled=disabled variant="primary" class="float-right">Senden</b-button>
  </b-form>
</template>

<script>
export default {
  name: 'Email',
  props: ['user'],

  data: function () {
    return {
      email: '',
      confirmation: ''
    }
  },

  computed: {
    disabled: function () {
      if (this.email.trim() === '') {
        return true
      }

      if (this.confirmation !== this.email) {
        return true
      }

      if (this.email === this.user.email) {
        return true
      }

      return false
    }
  },

  methods: {
    send: function () {
      this.axios.put('users/me/email', JSON.stringify({email: this.email}))
        .then((rsp) => {
          this.$eventHub.$emit('alertInfo', 'Email erfolgreich an ' + rsp.data.email + ' gesendet. Bitten klicken Sie zur Bestätigung auf den Link in der Email')
        })
        .catch((err) => {
          this.$eventHub.$emit('alertError', err)
        })
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/user/Email.vue